/**
 * Property List Carousel Runtime
 */
import { initCarousel } from '../../_shared/carousel';

initCarousel('property-list');
